import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';

const ITEM_HEIGHT = 48;

function MenuContainer({ options, event, anchorEl, openOptions, handleClose }) {
  return (
    <Menu
      id="long-menu"
      MenuListProps={{
        'aria-labelledby': 'long-button',
      }}
      anchorEl={anchorEl}
      open={openOptions}
      onClose={handleClose}
      PaperProps={{
        style: {
          maxHeight: ITEM_HEIGHT * 4.5,
          width: '15ch',
          justifyContent: 'center',
        },
      }}
    >
      {options.map((option, index) => (
        <MenuItem
          key={option}
          onClick={() => {
            event(index);
          }}
          style={{ width: '15ch' }}
        >
          {option}
        </MenuItem>
      ))}
    </Menu>
  );
}

export default MenuContainer;
